import logo from './logo-v2.png';

export default logo;
